import React, { useEffect, useMemo, useRef, useState, useCallback } from 'react';
import { useParticipantIds, useDailyEvent, useDaily } from '@daily-co/daily-react';
import { useRecoilState, useSetRecoilState, useRecoilValue } from 'recoil';
import { isAuthAtom, isAuthLoadedAtom } from './State';
import { onAuthStateChanged, getAuth } from 'firebase/auth';
export default function AuthCheck() {
  const [authState, setAuthState] = useRecoilState(isAuthAtom);
  const [isAuthLoadedState, setIsAuthLoadedState] = useRecoilState(isAuthLoadedAtom);

  //ログイン情報取得
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(getAuth(), (currentUser) => {
      if (currentUser != null) {
        // console.log(currentUser);
        // console.log('ログインしてます');
        setAuthState(true);
        localStorage.setItem('isAuth', true);
      } else {
        // console.log('ログインしてません');
        setAuthState(false);
        localStorage.removeItem('isAuth');
      }

      if (isAuthLoadedState == false) {
        setIsAuthLoadedState(true);
      }
    });
    return () => unsubscribe();
  }, []);
  //レンダービュー
  return false;
}
